export class AlertBlock {
    constructor(inputSelector) {
        this.$alertButton = $(inputSelector);
    }

    init() {
        this.$alertButton.click(e => this.alertDismissButtonClick(e));
        this.$alertButton.each((index, value) => this.hideAlert(index, value));
    }

    hideAlert(index, value) {
        let button = $(value);
        let alertId = button.data("alert-id");
        let alert = button.closest('.alert');
        let alwaysShow = alert.data("always-show");

        if (this.checkCookie('alert-box-' + alertId) && alwaysShow !== "True")
            alert.hide();
        else
            alert.show();
    }

    alertDismissButtonClick(e) {
        // Do not perform default action when button is clicked
        e.preventDefault();
        let button = $(e.currentTarget);
        let alertId = button.data("alert-id");

        /* If you just want the cookie for a session don't provide an expires
         Set the path as root, so the cookie will be valid across the whole site */
        this.setCookie('alert-box-' + alertId, 'closed', 1);
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    checkCookie(key) {
        let cookie = this.getCookie(key);
        if (cookie != "") {
            return true;
        } else {
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./frontend/js/components/ost.alertblock.js